/* esm.sh - bitcoinjs-lib@6.1.7 */
import "/node/buffer.mjs";
export * from "/*bitcoinjs-lib@6.1.7/esnext/bitcoinjs-lib.mjs";
export { default } from "/*bitcoinjs-lib@6.1.7/esnext/bitcoinjs-lib.mjs";
